//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import DateField from '../../components/Field/DateField.vue'
import { createFieldConfig } from '../../components/QSelectUtils.js'
import { getEmptyAdmittanceRecord } from './EmployeeAdmittanceRecord.js'

export default {
  name: 'EmployeeSkillCard',
  components: {
    ItemsSearchField,
    DateField
  },
  props: {
    admittance: {
      type: Boolean,
      default: false
    },
    blocked: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: function () {
        return null
      }
    },
    records: {
      type: Array,
      required: true
    },
    alreadyAddedQualificationTypesKeys: {
      type: Set,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    requiredAdmittance: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isNew: !this.record,
      recordLocal: this.record ? Object.assign({}, this.record) : getEmptyAdmittanceRecord(this.requiredAdmittance),
      qualificationTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getQualificationTypes })
    }
  },
  computed: {
    qualificationTypeValue: {
      get: function () {
        return this.recordLocal && this.recordLocal.qualificationType ? [this.recordLocal.qualificationType] : []
      },
      set: function (value) {
        this.setQualificationType(value && value.length ? value[0] : null)
      }
    }
    // employeeQualificationTypes: function () {
    //   return new Set(this.records.map(record => record.qualificationTypeKey))
    // }
  },
  methods: {
    validate: function () {
      let valid = true
      valid &= this.$refs.qualificationType.validate()
      if (this.$refs.planReceiveTime) {
        valid &= this.$refs.planReceiveTime.validate()
      }
      if (this.$refs.reason) {
        valid &= this.$refs.reason.validate()
      }
      return valid
    },
    getQualificationTypes: function () {
      // const employeeQualificationTypes = this.employeeQualificationTypes
      return axiosGet({
        url: '/service/delta/employee/getQualificationTypes?admittance=true&driver=false',
        onSuccess: (response) => {
          if (!this.blocked) {
            return response.data.result.filter(qt => !this.alreadyAddedQualificationTypesKeys.has(qt.key))
          } else {
            return response.data.result
          }
        },
        onFailure: 'Ошибка получения списка доступных объектов'
      })
    },
    setQualificationType: function (qualificationType) {
      this.recordLocal.qualificationType = qualificationType
      this.recordLocal.name = qualificationType ? qualificationType.name : null
      this.recordLocal.qualificationTypeKey = qualificationType ? qualificationType.key : null
      this.recordLocal.isAdmittance = qualificationType ? qualificationType.isAdmittance : false
    },
    onApply: async function () {
      if (!this.validate()) {
        return
      }

      if (this.isNew) {
        this.records.push(this.recordLocal)
      } else {
        this.record.qualificationPosition = this.recordLocal.qualificationPosition || null
        if (this.blocked) {
          this.record.reason = this.recordLocal.reason
        } else {
          this.record.planReceiveTime = this.recordLocal.planReceiveTime
        }
      }
      this.$emit('cancel')
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
